export default class Room {
    constructor(tileObject, bgGroup, overlayGroup) {
        this.rect = new Phaser.Rectangle(tileObject.x, tileObject.y, tileObject.width, tileObject.height);
        this.id = tileObject.properties.id;
        this.items = [];
        this.doors = [];
        this.bgGroup = bgGroup;
        this.overlayGroup = overlayGroup;
        this.overlays = [];
        this.addAppendix(this.rect);
        if (typeof tileObject.properties.breachable === 'undefined') {
            console.warn("breachable is not exactly specified for room", this.id);
        }
        this.canBeBreached = tileObject.properties.breachable;
    }

    addAppendix(a) {
        let overlayBitmap = game.add.bitmapData(a.width, a.height);
        let overlaySprite = game.add.sprite(a.x, a.y, overlayBitmap, 0, this.overlayGroup);
        overlayBitmap.fill(255,255,255, 0.4);
        overlaySprite.visible = false;
        overlaySprite.tint = 0x101010;
        this.overlays.push(overlaySprite);

    }

    contains(item) {
        //console.log(this.rect, item.centerX || item.x, item.centerY || item.y);
        return this.rect.contains(item.centerX || item.x, item.bottom || item.y);
    }

    randomPoint(pad = 10) {
        let x = game.rnd.integerInRange(this.rect.left+pad, this.rect.right-pad);
        let y = game.rnd.integerInRange(this.rect.top+pad, this.rect.bottom-pad);
        return {x,y}
    }

    addBreach(breachObj) {
        let x = game.rnd.integerInRange(this.rect.left+10, this.rect.right-10);
        let y = game.rnd.integerInRange(this.rect.top+10, this.rect.bottom-10);
        breachObj.x = x;
        breachObj.y = y;
        this.bgGroup.add(breachObj);
        this.breach = breachObj;
        for (let overlaySprite of this.overlays) {
            overlaySprite.visible = true;
            overlaySprite.tint = 0xff0000;
            overlaySprite.alpha = 0.2;
            overlaySprite.tween = game.add.tween(overlaySprite).to({alpha: 0.3}, 500, null, true,0, -1, true);
        }
    }

    update() {
        if (this.breach && this.breach.disabled) {
            this.removeBreach();
        }
    }

    removeBreach(obj) {
        if (this.breach) {
            for (let overlaySprite of this.overlays) {
                overlaySprite.tween.stop();
                overlaySprite.visible = false;
            }
            if (!this.breach.disabled) {
                this.breach.disable(obj);
            }
            this.breach = undefined;
            this.enable();
            for (let door of this.doors) door.checkState();
        }
    }

    disable() {
        this.disabled = true;
        for (let overlaySprite of this.overlays) {
            overlaySprite.visible = true;
            overlaySprite.tint = 0x101010;
            overlaySprite.alpha = 1;
            if (overlaySprite.tween) overlaySprite.tween.stop();
        }
        for (let door of this.doors) door.checkState();
    }

    enable() {
        this.disabled = false;
        for (let overlaySprite of this.overlays) {
            overlaySprite.visible = false;
        }
        for (let door of this.doors) door.checkState();
    }
}


// WEBPACK FOOTER //
// ./src/objects/room.js